import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneService {
  private saudiTimezone = 'Asia/Riyadh';
  private localTimeZone = localStorage.getItem('timeZone');
  private today = moment().format("YYYY-MM-DD hh:mm A");
  /**
   * Converts a local time to Saudi time.
   * @param localTime - The local time in HH:mm format or Date object.
   * @param localTimezone - The timezone where the time was selected.
   * @returns The converted time in Saudi timezone in HH:mm format.
   */
  constructor() { }

  // utility method to concat date and time
  concatDateTime(date: string, time: string) {
    return date && time ? `${date} ${time}` : null;
  }

  // utility method to convert local time to saudi time
  convertToSaudiTime(localTime: any | Date, inputFormat: string, outputFormat: string): string {
    if (!localTime || localTime === '') {
      return null;
    }

    return moment
      .tz(localTime, inputFormat, this.localTimeZone)
      .tz(this.saudiTimezone)
      .format(outputFormat);
  }

  // utility method to convert saudi time to local time 
  convertToLocalTime(saudiTime: any | Date, inputFormat: string, outputFormat: string, translate: boolean = false, lang: string = 'en'): string {
    if (!saudiTime || saudiTime === '') {
      return null;
    }
    // Set the locale based on the `translate` flag
    const momentObj = moment
      .tz(saudiTime, inputFormat, this.saudiTimezone)
      .tz(this.localTimeZone);

    if (translate) {
      momentObj.locale(lang);
    }
    return momentObj.format(outputFormat);
  }

  // utility method to combine the concatination process with the convertion to local process 
  concatConvert2LocalTime(
    date: string,
    time: string,
    inputFormat?: string,
    outputFormat?: string,
    translate: boolean = false,
    lang: string = 'en'
  ): string {

    // call the concatination method 
    const concatenatedDateTime = this.concatDateTime(date, time);

    // call the convert to local method 
    return this.convertToLocalTime(
      concatenatedDateTime,
      inputFormat,
      outputFormat,
      translate,
      lang
    );
  }
}
